import Parse from 'parse';
import config from '../settings/config';

Parse.initialize(config.appId, config.jsKey);
//javascriptKey is required only if you have it on server.

Parse.serverURL = `${config.api_url}`;